import { Button, Divider, Flex, Space, Spacing, Text } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'

import { useTrackQuickStart } from '@features/quickStart/hooks'

import { QuickStartAction } from '../../../../types/quickStartAction'

interface QuickStartAccordionContentProps {
  description?: string
  primaryAction?: QuickStartAction
  secondaryAction?: QuickStartAction
}

export const QuickStartAccordionContent = ({
  description,
  primaryAction,
  secondaryAction,
}: QuickStartAccordionContentProps): ReactElement => {
  const { trackQuickStart } = useTrackQuickStart()

  const handlePrimaryActionClick = useCallback(() => {
    if (primaryAction) {
      trackQuickStart(primaryAction.trackingEvent)
      primaryAction.onClick?.()
    }
  }, [primaryAction, trackQuickStart])

  const handleSecondaryActionClick = useCallback(() => {
    if (secondaryAction) {
      trackQuickStart(secondaryAction.trackingEvent)
      secondaryAction.onClick?.()
    }
  }, [secondaryAction, trackQuickStart])

  return (
    <>
      <Flex gap={Spacing.S2}>
        <Space horizontal size="s32" />
        <Text colorVariant="discreet" variant="bodySM" weight="medium">
          {description}
        </Text>
      </Flex>
      {(primaryAction || secondaryAction) && (
        <>
          <Divider />
          <Flex gap={Spacing.S8}>
            {primaryAction && (
              <Button
                color="accent"
                onClick={handlePrimaryActionClick}
                size="md"
                to={primaryAction.to}
                variant="filled"
              >
                {primaryAction.label}
              </Button>
            )}
            {secondaryAction && (
              <Button
                icon={secondaryAction.icon}
                onClick={handleSecondaryActionClick}
                size="md"
                to={secondaryAction.to}
                variant="outlined"
              >
                {secondaryAction.label}
              </Button>
            )}
          </Flex>
        </>
      )}
    </>
  )
}
